import React, { FC, PropsWithChildren, useCallback } from 'react';
import fp from 'lodash/fp';
import VisibilitySensor from 'react-visibility-sensor';
import { Skeleton } from '@mui/material';

import { useDesktop, Stack } from 'Modules/ui3';

import { ContentBox, ContentBoxProps } from '../ContentBox';
import { NewsPreview, NewsPreviewProps } from '../NewsPreview';
import { SlideBaseProps } from '../Slider/types';


export const NewsSlideContainer: FC<PropsWithChildren<ContentBoxProps>> = ({
    children, ...props
}) => {
    const isDesktop = useDesktop();
    return (
        <ContentBox
            p={isDesktop ? 8 : 5}
            display='flex'
            flexDirection='column'
            whiteSpace='normal'
            width='100%'
            minHeight={isDesktop ? '364px' : '291px'}
            {...props}
        >
            {children}
        </ContentBox>
    );
};

export type NewsSlideProps = SlideBaseProps<NewsPreviewProps[]> & {
    needShow?: () => void;
}

export const NewsSlide: FC<NewsSlideProps> = ({ data, needShow }) => {
    const onVisible = useCallback(isVisible => isVisible && needShow && needShow(), [needShow]);

    return (
        <Stack spacing={2}>
            {data.map((news, idx) => fp.isEmpty(news) ? (
                <VisibilitySensor key={`slideIndex_${idx}`} onChange={onVisible}>
                    <NewsSlideContainer>
                        <Skeleton width='70%' />
                        <Skeleton width='100%' />
                        <Skeleton width='100%' />
                    </NewsSlideContainer>
                </VisibilitySensor>
            ) : (
                <NewsSlideContainer
                    key={fp.getOr(idx, 'Id', news)}
                    flex={1}
                    sx={{
                        cursor: 'pointer',
                        '& *': {
                            userSelect: 'none',
                            webkitUserSelect: 'none',
                            khtmlUserSelect: 'none',
                            mozUserSelect: 'none',
                            msUserSelect: 'none',
                        },
                    }}
                >
                    <NewsPreview {...news} />
                </NewsSlideContainer>
            ))}
        </Stack>
    );
};
